import { FuentesPuntajesDtoI } from "./FuentesPuntajesDto";

export class InforIndicadoresDtoI{
  numeroTotalFtes: any;
  numeroFtesReportaron: any;
  ic: any;
  icif: any;
  icifComple: any;
  icri: any;
  icriComple: any;
  icg: any;
  icgcomple: any;
  fuentesPunajes: FuentesPuntajesDtoI[];
  doc: string;
  pdf: string;
}
